import PropTypes from 'prop-types';

export const SelectPlanListStepProps = {
  locales: PropTypes.object.isRequired,
  buttonsProps: PropTypes.object.isRequired,
  userAvailablePlans: PropTypes.array.isRequired,
  selectedObject: PropTypes.object.isRequired,
  handleSameDomain: PropTypes.func.isRequired,
  handleContinue: PropTypes.func.isRequired,
  loadedSites: PropTypes.bool.isRequired,
  loadingSites: PropTypes.bool.isRequired,
};
